import React from 'react';
import type { GameEligibility } from '../../types/games';
import { Card } from './ui';
import GameTodayResultCard from './GameTodayResultCard';

interface GameLockedCardProps {
  eligibility: GameEligibility | null;
}

const GameLockedCard: React.FC<GameLockedCardProps> = ({ eligibility }) => (
  <>
    <Card style={{ textAlign: 'center', marginTop: 40 }}>
      <div style={{ fontSize: 32 }}>🕗</div>
      <p style={{ color: 'var(--text-secondary, #6B5E3E)', marginTop: 8, fontSize: 14 }}>
        {eligibility?.reason === 'GAME_INACTIVE'
          ? 'This game is not available right now.'
          : eligibility?.reason === 'GOOGLE_URL_NOT_CONFIGURED'
            ? 'This game is not set up yet. Ask staff to configure the Google Review URL.'
            : eligibility?.reason === 'REVIEW_ALREADY_CLAIMED'
              ? "You've already claimed a Google Review reward at this restaurant."
              : "You've already played today. Come back tomorrow!"}
      </p>
    </Card>
    {eligibility?.todayResult && (
      <GameTodayResultCard
        result={eligibility.todayResult}
        title={eligibility.reason === 'REVIEW_ALREADY_CLAIMED' ? 'YOUR REWARD' : "TODAY'S RESULT"}
      />
    )}
  </>
);

export default GameLockedCard;
